import { v } from 'convex/values';

export const LOCALES = ['fr', 'de', 'en', 'it'] as const;

export type Locale = (typeof LOCALES)[number];

/** Convex validator for locale fields. */
export const localeValidator = v.union(
  v.literal('fr'),
  v.literal('de'),
  v.literal('en'),
  v.literal('it'),
);
